import { InjectionToken } from '@angular/core';

export interface UserListPermissionsConfig {
  canViewUsers: boolean;
  canAddUser: boolean;
  canDeleteUser: boolean;
  canActivateUser: boolean;
  canDeactivate: boolean;
  canBatchUpload: boolean;
  isRoleColumnVisible: boolean;
  isOrganizationColumnVisible: boolean;
  isLocationInfoVisible: boolean;
  isOldUserListAvailable: boolean;
  organizationRolesFeatureFlag?: boolean;
}

export const USER_LIST_PERMISSIONS_CONFIG = new InjectionToken<UserListPermissionsConfig>('UserListPermissionsConfig');
